(function() {
	var push = 'push';
	var readyState = 'readyState';
	var onreadystatechange = 'onreadystatechange';
	// var head = document.getElementsByTagName('head')[0];
	var list = {};
	var ids = {};
	var delay = {};
	var scripts = {};
	var scriptpath;
	var urlArgs;

	function every(ar, fn) {
		for (var i = 0, j = ar.length; i < j; ++i) {
			if (!fn(ar[i])) {
				return false;
			}
		}
		return 1;
	}

	function each(ar, fn) {
		every(ar, function(el) {
			fn(el);
			return 1;
		});
	}

	function tophat(paths, idOrDone, optDone) {
		paths = paths[push] ? paths : [paths];
		var idOrDoneIsDone = idOrDone && idOrDone.call,
			done = idOrDoneIsDone ? idOrDone : optDone,
			id = idOrDoneIsDone ? paths.join('') : idOrDone,
			queue = paths.length;
		if (tophat.cached(paths, done)) {
			return;
		}

		function loopFn(item) {
			return item.call ? item() : list[item];
		}
		function callback() {
			if (!--queue) {
				list[id] = 1;
				done && done();
				for (var dset in delay) {
					every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
				}
			}
		}
		setTimeout(function() {
			each(paths, function loading(path, force) {
				if (path === null) return callback();

				if (!force && !/^https?:\/\//.test(path) && scriptpath) {
					path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
				}

				if (scripts[path]) {
					if (id) ids[id] = 1;
					return (scripts[path] == 2) ? callback() : setTimeout(function() { loading(path, true); }, 0);
				}

				scripts[path] = 1;
				if (id) ids[id] = 1;
				create(path, callback);
			});
		}, 0);
		return this;
	}

	function create(path, fn) {
		var el = document.createElement('script'), loaded;
		el.onload = el.onerror = el[onreadystatechange] = function() {
			if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
			el.onload = el[onreadystatechange] = null;
			loaded = 1;
			scripts[path] = 2;
			fn();
		};
		el.async = 1;
		el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
		document.body.appendChild(el);
		// head.appendChild(el);
	}

	tophat.get = create;

	tophat.order = function(scripts, id, done) {
		(function callback(s) {
			s = scripts.shift();
			!scripts.length ? tophat(s, id, done) : tophat(s, callback);
		}());
	};

	tophat.path = function(p) {
		scriptpath = p;
	};

	tophat.urlArgs = function(str) {
		urlArgs = str;
	};

	tophat.ready = function(deps, ready, req) {
		deps = deps[push] ? deps : [deps];
		var missing = [];
		!each(deps, function(dep) {
			list[dep] || missing[push](dep);
		}) && every(deps, function(dep) {
			return list[dep];
		}) ? ready() : ! function(key) {
			delay[key] = delay[key] || [];
			delay[key][push](ready);
			req && req(missing);
		}(deps.join('|'));
		return tophat;
	};

	var pending = [];

	/**
	 * Loads the scripts from window.localStorage if the version is correct and the
	 * the files are available in the cache.
	 * @param {array} paths Array of paths to fetch from localStorage if available
	 * @param {Function} cb Callback to call when done
	 */
	tophat.cached = function(paths, cb) {
		if (window.isDevelopment !== 'true' && window.localStorage.th_version === window.buildVersion) {
			var absent = paths.find(function(p) {
				return !window.localStorage['th_' + p];
			});

			if (!absent) {
				// Load from cache
				paths.forEach(function(p) {
					window.eval(window.localStorage['th_' + p]);
				});
				cb();
				return true;
			}
		}
		pending = pending.concat(paths);
	};

	function fetch(url) {
		return new Promise(function(resolve, reject) {
			var xhr = new XMLHttpRequest();

			xhr.onreadystatechange = function() {
				if (this.readyState === 4) {
					resolve(xhr.responseText);
				}
			};
			xhr.onerror = function(error) {
				reject(null);
			};
			xhr.open('GET', url, true);
			xhr.send();
		});
	}

	/**
	 * Fetches and caches in the local storage the scripts loaded so far via tophat.
	 * This allows these scripts to load faster on subsequent launches.
	 */
	tophat.cache = function() {
		var promises = pending.map(function(path) {
			return fetch(scriptpath + path).then(function(data) {
				window.localStorage['th_' + path] = data;
			});
		});
		return Promise.all(promises).then(function() {
			window.localStorage.th_version = window.buildVersion;
		});
	};

	tophat.done = function(idOrDone) {
		tophat([null], idOrDone);
	};

	window.tophat = tophat;
}());
